import React from 'react';
import PropTypes from 'prop-types';
import { Modal, Button, Icon } from 'semantic-ui-react';
import { connect } from 'react-redux';
import { submit } from 'redux-form';
import moment from 'moment';

import * as CommonStateSelectors from 'State/selectors';
import { PrintProductionRecordFieldEnum as Fields } from 'Common/FieldEnum';
import { withReportSubscription } from 'State/report/withReportSubscription';
import { ProductionRecordFieldEnum as ProdRecordFields } from 'Common/FieldEnum';
import { DATE_FORMAT_FOR_UI } from 'Common/Constants';
import { PRINT_PRODUCTION_MODAL_FORM_NAME } from 'Common/FormEnum';
import * as EditProductionSelectors from 'Pages/manageproduction/state/editproduction/selectors';

import { PrintProductionModalForm } from './PrintProductionModalForm';

class PrintProductionModal extends React.Component {
  static propTypes = {
    modalProps: PropTypes.object,
    modalTitle: PropTypes.string,
    reportFetching: PropTypes.bool,
    prodRecord: PropTypes.object,
    site: PropTypes.string,
  };

  static defaultProps = {
    reportFetching: false,
    prodRecord: {},
    site: '',
  };

  handleSubmit = formValues => {
    const { getReport } = this.props;
    getReport('Production/Report', formValues);
  };

  render() {
    const {
      modalTitle,
      modalProps,
      reportFetching,
      commonProdRecordProps,
      submit,
      prodRecord,
      site,
    } = this.props;
    const { onClose } = modalProps;

    return (
      <Modal {...modalProps}>
        <Modal.Header className="manage-menu-modal-header">
          {`Print Production Record - ${modalTitle}`}
          <Icon name="close" onClick={onClose} className="manage-menu-close" />
        </Modal.Header>
        <Modal.Content className="manage-menu-modal-content">
          <PrintProductionModalForm
            onSubmit={this.handleSubmit}
            commonProdRecordProps={commonProdRecordProps}
            initialValues={{
              [Fields.FromDate]: moment(
                prodRecord[ProdRecordFields.Date]
              ).format(DATE_FORMAT_FOR_UI),
              [Fields.ToDate]: moment(prodRecord[ProdRecordFields.Date]).format(
                DATE_FORMAT_FOR_UI
              ),
              [Fields.UsePlannedNumbers]: false,
              [Fields.SiteId]: prodRecord[ProdRecordFields.SiteId],
              [Fields.CycleMenuId]: prodRecord[ProdRecordFields.CycleMenuId],
            }}
            prodRecord={prodRecord}
            site={site}
          />
        </Modal.Content>
        <Modal.Actions>
          <div className="manage-menu-header-buttons">
            <Button onClick={modalProps.onClose} className="mnm-button-blue">
              Cancel
            </Button>
            <Button
              loading={reportFetching}
              className="mnm-button-blue"
              disabled={reportFetching}
              onClick={() => submit(PRINT_PRODUCTION_MODAL_FORM_NAME)}
            >
              Print
            </Button>
          </div>
        </Modal.Actions>
      </Modal>
    );
  }
}
const mapStateToProps = state => ({
  userName: CommonStateSelectors.getUserName(state),
  sitesMap: CommonStateSelectors.getSitesMap(state),
  modalTitle: EditProductionSelectors.getModalTitle(state),
});

const mapDispatchToProps = {
  submit,
};

PrintProductionModal = withReportSubscription(PrintProductionModal);

PrintProductionModal = connect(
  mapStateToProps,
  mapDispatchToProps
)(PrintProductionModal);

export { PrintProductionModal };



// WEBPACK FOOTER //
// ./src/pages/manageproduction/subpages/editproduction/components/PrintProductionModal.js